var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.6,
    height: 30.6,
    viewBox: "0 0 30.6 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.954,1.826,17.2,6.314a2.771,2.771,0,0,0,1.811,1.339l4.067.676c2.6.434,3.213,2.321,1.339,4.182l-3.162,3.162a2.768,2.768,0,0,0-.663,2.308L21.5,21.9c.714,3.1-.931,4.3-3.672,2.678l-3.812-2.257a2.756,2.756,0,0,0-2.525,0L7.674,24.573C4.946,26.192,3.288,24.981,4,21.9l.905-3.914a2.768,2.768,0,0,0-.663-2.308L1.082,12.511C-.779,10.649-.18,8.762,2.421,8.329l4.067-.676a2.777,2.777,0,0,0,1.8-1.339L10.53,1.826C11.754-.609,13.743-.609,14.954,1.826Z",
    transform: "translate(2.551 2.649)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector-2",
    "data-name": "Vector",
    fill: "none",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H30.6V30.6H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.9999961853027344 0.9999961853027344 L 0.9999961853027344 29.60010528564453 L 29.60010528564453 29.60010528564453 L 29.60010528564453 0.9999961853027344 L 0.9999961853027344 0.9999961853027344 M -3.814697265625e-06 -3.814697265625e-06 L 30.60010528564453 -3.814697265625e-06 L 30.60010528564453 30.60010528564453 L -3.814697265625e-06 30.60010528564453 L -3.814697265625e-06 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.47ed3acd807861bd375cf7dea8a7dca4.svg";
export { ForwardRef as ReactComponent };